import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit {

  private paramSubscription!: Subscription;
  productId: string;
  productsArr: any = [
    {
      id: 'goldol-5w30-10000sn-synthetic-engine-oil-uae',
      image: 'assets/img/Oil-Images/5W30-1.jpeg',
      metaTitle: '5W30 Synthetic Engine Oil in Sharjah | GOLDOL 10000SN',
      metaDescription: 'Shop high-quality 5W30 fully synthetic engine oil in Sharjah. GOLDOL 10000SN delivers superior protection, efficiency & smooth engine performance.',
      metaKeyword: '5w 30 synthetic engine oil Sharjah',
      name: 'GOLDOL 5W30 10000SN Synthetic Engine Oil',
      description: "<div class='product-page-description'><p>Our GOLDOL 5W30 10000SN Synthetic Engine Oil serves as Golden Drop Oils' top product which provides superior protection together with unmatched performance to today's petrol and diesel engine systems.</p><p>Our 5w 30 synthetic engine oil Sharjah achieves remarkable performance during start-up operations in cold conditions as well as high sustained RPM operations because of its ultra pure base stocks and advanced additive package. It remains the foremost selection for drivers throughout Sharjah together with the overall UAE region.</p></div>",
      whyBuy: "<div class='product-page-why-buy'><h2 class='h4-title'>Why Buy from Golden Drop Oils?</h2><p>Golden Drop Oils functions as your preferred provider to deliver 20w50 engine oil services in Dubai locations. We combine:</p><ul><li>We modifies its product formulations specifically for UAE climate conditions through local expertise.</li><li>All produced batches of product undergo thorough examination procedures in ISOcertified testing facilities.</li><li>The reliable distribution network provides fast delivery of genuine GOLDOL products throughout the entire nation.</li><li>A team of engineers from our company assists you with product selection and engine maintenance timetable decisions.</li></ul></div>",
      benefits: "<div class='product-page-why-buy'><h2 class='h4-title'>Application of 5w 30 synthetic engine oil Sharjah</h2><p>The Sharjah-formulated 5w 30 synthetic engine oil by GOLDOL provides optimal performance for turbocharged vehicles together with high-performance sedans and light commercial vans driving on city and desert terrain.</p><p>The engine fluid upholds both API SN and ACEA A3/B4 certification standards that allow it to work with modern engine systems and pollution control systems. GOLDOL 5W30 10000SN provides trustable protection combined with efficiency to commuters alongside sport drivers while Golden Drop Oils delivers local technical support across Sharjah and its surrounding areas.</p></div>",
      details: [
        {
          id: 11,
          point: 'APLStandards: APISP, SN'
        },
        {
          id: 12,
          point: 'ILSAC Standards: GF-6A, GF-6B'
        },
        {
          id: 13,
          point: 'ACEA Standards: ACEA:A5/B5 (HTHS < 3.5), A3/B3, A3/B4'
        },
        {
          id: 14,
          point: 'Manufacturer Approvals:'
        },
        {
          id: 15,
          point: 'MB 229.3 / 229.5'
        },
        {
          id: 16,
          point: 'Ford WSS-M2C913-C/D, WSS-M2C925-B'
        },
        {
          id: 17,
          point: 'Renault RN0700 / RN0710'
        },
        {
          id: 18,
          point: 'VW 502.00 / 505.00'
        },
        {
          id: 19,
          point: 'PSA B71 2296'
        },
        {
          id: 20,
          point: 'Opel GM-LL-B-025'
        },
      ]
    },
    {
      id: 'goldol-10w-40-semi-synthetic-engine-oil-uae',
      image: 'assets/img/Oil-Images/10W40-1.jpeg',
      metaTitle: '10W40 Semi Synthetic Engine Oil UAE | GOLDOL High-Performance Lubricant',
      metaDescription: 'Get reliable 10W40 semi synthetic engine oil for petrol & diesel engines. GOLDOL offers balanced protection, fuel efficiency & engine longevity.',
      metaKeyword: '10w 40 semi synthetic engine oil',
      name: 'GOLDOL 10W40 Semi Synthetic Engine Oil',
      description: "<div class='product-page-description'><p>Golden Drop Oils presents a 10w 40 semi synthetic engine oil product which gives dependable protection and operational reliability to contemporary petrol and diesel engines. GOLDOL 10W40 achieves exceptional wear protection and financial value by combining premium synthetic and mineral base stocks with premium additives which makes it suitable for all drivers in the UAE.</p></div>",
      whyBuy: "<div class='product-page-why-buy'><h2 class='h4-title'>Key Specifications?</h2><ul><li><p class='mb-0'><span class='fw-semibold'>Viscosity Grade:</span> SAE 10W‑40 for balanced cold‑start flow and high‑temperature stability</p></li><li><p class='mb-0'><span class='fw-semibold'>API SN/CF:</span> Meets the latest standards for petrol and diesel engines</p></li><li><p class='mb-0'><span class='fw-semibold'>Base Oil:</span> The base stock of this product combines semi-synthetic components to improve its oxidation resistance.</p></li><li><p class='mb-0'><span class='fw-semibold'>Additives:</span> Zinc DTP, anti‑foam agents, detergents/dispersants, friction modifiers</p></li><li><p class='mb-0'><span class='fw-semibold'>Shear Stability:</span> Retains film strength under heavy loads and long‑duration driving</p></li></ul></div>",
      benefits: "<div class='product-page-why-buy'><h2 class='h4-title'>Benefits of 10w 40 semi synthetic engine oil</h2><ul><li>Engine life benefits substantially because a resilient film develops from high zinc along with phosphorus which minimizes metal contact between components.</li><li>The premium detergents maintain the cleanliness of pistons rings and valves by stopping sludge formation for enhanced operational smoothness.</li><li>The synthetic components show resistance to thermal and oxidation breakdown that enables engines to uphold optimum viscosity during both urban traffic stop-and-start sessions and extended highway travelling.</li><li>Engine fuel economy benefits from reduction in inner mechanical drag which leads to increased mileage efficiency.</li></ul></div>",
      application: "<div class='product-page-description'><h2 class='h4-title'>Application of 10w 40 semi synthetic engine oil</h2><p>The 10w 40 semi synthetic engine oil from our company functions well in various vehicle types including compact cars, SUVs, light commercial vans, together with high-performance models. This engine fluid functions best under metropolitan and dry environments to give dependable lubrication throughout brief travels and extensive drives along with all points in the middle.</p><p>Customers who select GOLDOL 10w40 engine oil from Golden Drop Oils will experience smooth engine startups together with consistent operation and long-lasting engine health in all areas of the Emirates' territory.</p></div>",
      details: [
        {
          id: 21,
          point: 'API Standards: API SN/CE'
        },
        {
          id: 22,
          point: 'ACEA Standards: ACEA:A3/B3, A3/B4'
        },
        {
          id: 23,
          point: 'Manufacturer Approvals:'
        },
        {
          id: 24,
          point: 'MB 229.1 / 229.3 / 229.5'
        },
        {
          id: 25,
          point: 'Ford WSS-M2C913-C/D, WSS-M2C925-B'
        },
        {
          id: 26,
          point: 'Renault RN0700 / RN0710'
        }
      ]
    },
    {
      id: 'goldol-20w50-5000SL-engine-oil-dubai-uae',
      image: 'assets/img/Oil-Images/20W50-1.jpeg',
      metaTitle: 'Buy 20W50 Engine Oil in Dubai | GOLDOL 5000SL High Performance',
      metaDescription: 'Discover premium 20W50 engine oil in Dubai with GOLDOL 5000SL – ideal for older engines. Smooth performance, wear protection, and extended engine life.',
      metaKeyword: '20w50 engine oil dubai',
      name: 'GOLDOL 20W50 5000SL Engine Oil',
      description: "<div class='product-page-description'><p>The high-performance lubricant GOLDOL 20w50 engine oil dubai from Golden Drop Oils serves older petrol and diesel engines functioning in harsh conditions. The 20W50 premium oil made for the environment of UAE delivers top-notch support for wear protection and provides excellent stability under heat conditions together with superior engine cleanliness.</p><p>GOLDOL 5000SL offers drivers in the Emirates reliable engine protection because it contains advanced additives and top-quality base oils which enable smooth operation and reduced sludge formation and extended engine durability.</p></div>",
      whyBuy: "<div class='product-page-why-buy'><h2 class='h4-title'>Why Buy from Golden Drop Oils?</h2><p>Golden Drop Oils functions as your preferred provider to deliver 20w50 engine oil services in Dubai locations. We combine:</p><ul><li>We modifies its product formulations specifically for UAE climate conditions through local expertise.</li><li>All produced batches of product undergo thorough examination procedures in ISOcertified testing facilities.</li><li>The reliable distribution network provides fast delivery of genuine GOLDOL products throughout the entire nation.</li><li>A team of engineers from our company assists you with product selection and engine maintenance timetable decisions.</li></ul></div>",
      benefits: "<div class='product-page-why-buy'><h2 class='h4-title'>Benefits of Using Our 20W50 Engine Oil Dubai</h2><ul><li>We modifies its product formulations specifically for UAE climate conditions through local expertise.</li><li>All produced batches of product undergo thorough examination procedures in ISOcertified testing facilities.</li><li>The reliable distribution network provides fast delivery of genuine GOLDOL products throughout the entire nation.</li><li>The friction modifier system in your oil helps decrease drag which produces superior fuel efficiency but maintains strong protection capabilities.</li></ul><p class='mt-3'>The GOLDOL 20w50 engine oil dubai from Golden Drop Oils provides dependable performance in every corner of the Emirates region.</p></div>",
      details: [
        {
          id: 31,
          point: 'API Standards: API SN/CF'
        },
        {
          id: 32,
          point: 'ACEA Standards: ACEA A3/B3, A3/B4'
        },
        {
          id: 33,
          point: 'Manufacturer Approvals:'
        },
        {
          id: 34,
          point: 'MB 226.5 / 229.1 / 229.3 / 229.5'
        },
        {
          id: 35,
          point: 'VW 501.01 / 505.00'
        },
        {
          id: 36,
          point: 'Renault RNO700 / RNO71O.'
        },
        {
          id: 37,
          point: 'Porsche A40'
        }
      ]
    },
    {
      id: 'goldol-super-toyota-engine-oil-5w30-uae',
      image: 'assets/img/Oil-Images/5W30-1.jpeg',
      metaTitle: 'Toyota 5W30 Engine Oil UAE | GOLDOL Super Synthetic Formula',
      metaDescription: 'Buy premium 5W30 engine oil for Toyota vehicles. GOLDOL Super offers superior performance, engine cleanliness & fuel economy across UAE.',
      metaKeyword: 'toyota engine oil 5w30',
      name: 'GOLDOL Super Toyota Engine Oil 5W30',
      description: "<div class='product-page-description'><p>GOLDOL Super Toyota Engine Oil 5W30 represents a specialized product from Golden Drop Oils designed for modern Toyota engines operating within UAE conditions to deliver smooth and reliable engine performance. Each drive delivers protection and efficiency in combination with clean operation because this advanced engine oil uses high-performance base oils and additives during its design stage.</p></div>",
      whyBuy: "<div class='product-page-why-buy'><h2 class='h4-title'>Key Specifications?</h2><ul><li>SAE Grade: 5W30</li><li>API Service Classification: SN/CF</li><li>Excellent oxidation and thermal stability</li><li>Superior low-temperature performance</li><li>Reduced volatility for less oil consumption</li><li>Meets latest OEM standards for Toyota engines</li></ul></div>",
      benefits: "<div class='product-page-why-buy'><h2 class='h4-title'>Benefits of Toyota Engine Oil 5W30</h2><p> The outstanding protection capabilities of GOLDOL’s Toyota engine oil 5W30 shield the engine from wear while fighting both sludge and deposits in your system. The oil extends engine life and produces outstanding fuel efficiency and starts efficiently under cold weather conditions.</p><p>Due to its low viscosity, Toyota engine oil rapidly moves through the system which cuts engine drag that results in higher power and better efficiency. A superior additive composition in this product cleans engine internals to protect the overall health of the engine system.</p></div>",
      application: "<div class='product-page-description'><h2 class='h4-title'>Application of Toyota Engine Oil 5W30</h2><p>Toyota passenger cars together with their SUVs and light trucks utilize this product as their engine oil standard. All Toyota models that need 5W30 specification benefit from superior protection when driven in urban areas of Sharjah or highway distances across Dubai with GOLDOL’s Toyota engine oil 5W30.</p></div>",
      details: [
        {
          id: 41,
          point: 'APLStandards: APISP, SN'
        },
        {
          id: 42,
          point: 'ILSAC Standards: GF-6A, GF-6B'
        },
        {
          id: 43,
          point: 'ACEA Standards: ACEA:A5/B5 (HTHS < 3.5), A3/B3, A3/B4'
        },
        {
          id: 44,
          point: 'Manufacturer Approvals:'
        },
        {
          id: 45,
          point: 'MB 229.3 / 229.5'
        },
        {
          id: 46,
          point: 'Ford WSS-M2C913-C/D, WSS-M2C925-B'
        },
        {
          id: 47,
          point: 'Renault RN0700 / RN0710'
        },
        {
          id: 48,
          point: 'VW 502.00 / 505.00'
        },
        {
          id: 49,
          point: 'PSA B71 2296'
        },
        {
          id: 50,
          point: 'Opel GM-LL-B-025'
        },
      ]
    }
  ];
  currentProduct: any;

  constructor(public route: ActivatedRoute, private router: Router, private titleService: Title, private metaService: Meta) { }

  ngOnInit(): void {
    this.paramSubscription = this.route.paramMap.subscribe(params => {
      this.productId = params.get('productId'); // ✅ Updates when navigating within the same page
      this.currentProduct = this.getProductById(this.productId);
      this.titleService.setTitle(this.currentProduct?.metaTitle);
      this.metaService.updateTag({ name: 'description', content: this.currentProduct?.metaDescription });
      this.metaService.updateTag({ name: 'keywords', content: this.currentProduct?.metaKeyword });
    });
  }

  getProductById(id: any): any {
    return this.productsArr.find(product => product.id == id);
  }

  ngOnDestroy(): void {
    if (this.paramSubscription) {
      this.paramSubscription.unsubscribe(); // ✅ Prevent memory leaks
    }
  }

}
